module.exports = __webpack_public_path__ + "img/qrcode_foryipai.9f6727ff.jpg";